import Scrollbar from './src/main';

Scrollbar.install = function(Vue) {
  Vue.component(Scrollbar.name, Scrollbar);
};

export default Scrollbar;



// WEBPACK FOOTER //
// ./src/components/scrollbar/index.js